import { render } from "./Branding.vue?vue&type=template&id=e5d77c4e&scoped=true&ts=true"
import script from "./Branding.vue?vue&type=script&lang=ts"
export * from "./Branding.vue?vue&type=script&lang=ts"

import "./Branding.vue?vue&type=style&index=0&id=e5d77c4e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d77c4e"]])

export default __exports__